/**
 * @export
 * @class Contact
 */
import { BaseModule } from '../../helpers/base_module';
import { get } from '../../helpers/utilities';
import { GoogleMap } from '../../modules/google-map';

import { ContactForm } from './form';


export class Contact extends BaseModule {
    public static id = 'contact';

    
    /**
     * Creates an instance of Contact.
     * 
    * @memberof Contact
     */
    constructor() {
        super()
        super.makePublic('contact');

        this.contactForm();
    }


    /**
     * Initiates our Google Map
     * 
     * @public
     * @memberof Contact
     */
    public render(): void {
        const container: Element = <HTMLElement>document.getElementById('js-contact__map');
        if(container) {
            const latitude  = parseFloat(<string>container.getAttribute('data-latitude'));
            const longitude = parseFloat(<string>container.getAttribute('data-longitude'));

            // Initiate the map
            if(latitude && longitude) {
                new GoogleMap({
                    container,
                    latitude,
                    longitude
                });
            }
        }
    } 


    /**
     * Initialise our contact form logic.
     * 
     * @private
     * @returns void
     */
    private contactForm(): void {
        const container = get('.js-contact-form') as Element;
        if(container) new ContactForm(container);
    }
}
